import { cn } from 'lib/utils';
import useOnboardingStore from 'stores/onboardingStore';

const ProgressBar = () => {
  const { percentCompleted, nextStep } = useOnboardingStore();

  return (
    <div
      onClick={() => {
        if (process.env.NODE_ENV === 'development') nextStep();
      }}
      className={cn(
        percentCompleted === 0 ? 'opacity-0' : '',
        'inline-block relative w-[300px] bg-gray-400 bg-opacity-20 rounded-[10px] mx-auto p-[2px]'
      )}
    >
      <div
        className="block relative rounded-md h-[4px] overflow-hidden transition-[width] duration-300 ease-out"
        style={{ width: `${percentCompleted * 100}%` }}
      >
        <div className="block relative w-[300px] h-full bg-gradient-to-r from-[#5865F2] to-[#7D15B1]" />
      </div>
    </div>
  );
};

export default ProgressBar;
